/* eslint-disable no-console */
import { useEffect, useState } from 'react';
import {
  getOrFetchSipStatus,
  peekSipStatusCache
} from '../infrastructure/voiceSipStatusCache';
import normalizeVoiceSipEnabled from '../domain/voiceSipStatus';

/**
 * Retailer-level SIP readiness gate (parity with fonema's `isSipEnabledFonema`).
 *
 * Fails closed: the runtime stays gated off until Mercately confirms SIP is
 * ready (`sipEnabled: true`). A failed check keeps the gate closed.
 *
 * Uses the shared aggregate SIP status cache (same GET as outbound line gate).
 *
 * @returns {{ isVoiceSipEnabled: boolean }}
 */
export default function useVoiceSipStatus() {
  const [isVoiceSipEnabled, setIsVoiceSipEnabled] = useState(() => (
    normalizeVoiceSipEnabled(peekSipStatusCache())
  ));

  useEffect(() => {
    let cancelled = false;

    (async () => {
      try {
        const payload = await getOrFetchSipStatus();
        if (!cancelled) {
          setIsVoiceSipEnabled(normalizeVoiceSipEnabled(payload));
        }
      } catch (error) {
        console.error('[voice-sip-status] check failed — runtime stays gated off:', error);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  return { isVoiceSipEnabled };
}
